import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'framer-motion'
import { isEmpty, uniqueId } from 'lodash'
import { getValue } from '../Hero/functions'
import Metric from './Metric'
import { getProperties } from './functions'

HighlightsCounter.propTypes = {
  data: PropTypes.object,
}

export default function HighlightsCounter({ data }) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const { imageData, leftGroup, rightGroup, metrics, metrics2 } = getProperties(data)

  const getMetrics = (item) => {
    const data = item?.data
    const key = uniqueId()

    return (
      <React.Fragment key={key}>
        <Metric {...data} />
      </React.Fragment>
    )
  }

  if (isEmpty(data)) return null

  return (
    <section
      className="bg-eerie-black  text-white pb-[126px] pt-[126px] lg:pb-[139px] lg:pt-[139px]"
      ref={ref}
    >
      <div className="main-container h-full flex flex-col">
        <div className="w-full lg:border-b lg:border-b-isabelline pb-[49px] lg:pb-[33px] lg:mb-[45px]">
          <span className="paragraph text-[20px] text-white block uppercase text-nowrap">
            {data?.subtitle}
          </span>
          <h3 className="heading2 text-white uppercase text-[45px] leading-[45px] md:text-[68px] leading-[68px] lg:text-[70px] lg:text-nowrap  lg:leading-[70px]">
            {data?.title}
          </h3>
        </div>

        <div className="flex flex-wrap justify-center gap-[66px] md:justify-start lg:gap-8 aic-2k:gap-[82px] aic-2k:items-center">
          <img
            className="rounded-[46px]  w-full md:max-w-[300px] md:max-h-[458px] aic-2k:max-w-[453px]"
            src={imageData?.url}
            alt={getValue(imageData?.alt)}
            title={getValue(imageData?.title)}
            description={getValue(imageData?.description)}
            caption={getValue(imageData?.caption)}
            author={getValue(imageData?.author)}
          />

          {isInView ? (
            <div className="flex flex-wrap gap-[82px] lg:gap-8">
              <div>
                <span className="paragraph leading-none mb-7 aic-2k:text-[20px] aic-2k:leading-[27.54px] uppercase text-white block">
                  {leftGroup?.group_name}
                </span>

                {!isEmpty(metrics) ? (
                  <div className="flex flex-wrap lg:min-w-[520px] w-full md:max-w-[490px] aic-2k:max-w-[580px] gap-x-12 lg:gap-x-8 aic-2k:gap-x-12 gap-y-8 lg:gap-y-12">
                    {metrics?.map(getMetrics)}
                  </div>
                ) : null}
              </div>

              <div>
                <span className="paragraph leading-none mb-7 aic-2k:text-[20px] aic-2k:leading-[27.54px] uppercase text-white block">
                  {rightGroup?.group_name}
                </span>
                {!isEmpty(metrics2) ? (
                  <div className="flex flex-col w-full gap-x-12 gap-y-8 lg:gap-y-12">
                    {metrics2?.map(getMetrics)}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}
